const Form093TC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申請資料",
        confirmation: "確認",
    },
    label: {
        header: {
            headerOne: "重要事項",
        },
        // statement: "本人已參閱及明白｢個人資料收集聲明｣。",
        statement: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamStatement: "本人明白需透過「智方便+」帳戶以辧理申請。",
        schoolSessionOption: {
            am: "上午",
            pm: "下午",
            wholeDay: "全日",
        },
        title: "請在填寫前，詳細閱讀列載於附頁的個人資料收集聲明。",
        information: "基本資料",
        serial: "編號",
        nameOfSchool: "學校名稱",
        schoolCode: "學校編號",
        schoolSession: "授課時間",
        schoolTelephoneNo: "學校電話號碼",
        nameOfStaffEn: "職員姓名(全名) (英文)",
        nameOfStaffCh: "職員姓名(全名) (中文)",
        staffReference: "員工檔號",
        descriptionOfChangeOrDiscrepancy: "敘述更改/差異之處",
        informationInSalariesGrantReport: "薪金津貼報表內的資料",
        correctData: "正確資料",
        refOfSchoolDevelopmentOfficerApproval:
            "學校發展主任的批准書檔號 (如有)",
        dateOfSchoolDevelopmentOfficerApproval:
            "學校發展主任的批准書日期(如有)",
        lastDateOfEmployment: "最後受僱之日期",
        notificationOfTermination: "如通知離職事項，請提供下列資料",
        terminationReasonCode: "離職原因",
        terminationReasonCodeOption: {
            1: "辭職",
            2: "退休",
            3: "結束合約",
            4: "提前解約",
            5: "解僱",
            6: "死亡",
            7: "其他 ",
        },
        others: "請詳述",
        payment: "是否需要繳交代通知金?",
        paymentOption: {
            yes: "是",
            no: "否",
        },
        amount: "如是，款額",
        amount1: "款額",
        name: "姓名",
        post: "職位",
        postOption: {
            schoolHead: "校長",
            supervisor: "校監",
        },
        supervisorOrHeadOfSchoolName: "校監/校長姓名",
    },
    importantNotesContent: {
        // note1: "個人資料收集聲明",
        // note2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途：",

        // note16: "辦理與聘用有關的事宜；",
        // note17: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        // note18: "進行核數工作； ",
        // note19: "進行研究及統計資料，以便規劃教育服務；",
        // note20: "處理有關教育專業人員發展的事宜；",
        // note21: "執行《教育條例》、《教育規例》及附屬《補助／津貼學校公積金規則》（第279章）。",
        // note22: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        // note23: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
        // note24: "根據《個人資料（私隱）條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        // note25: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局公積金組一級會計主任提出。",
        // five page
        title: "個人資料收集聲明",
        p_title: "收集個人資料的目的",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_a: "處理、核實及查證僱傭相關事宜，包括聘用、培訓及職業前途發展、薪酬及福利、員工關係、通訊和程序遵行；",
        p1_b: "就上文(a)項所述僱傭相關事宜的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；以及",
        p1_d: "編製統計資料、研究及政府刊物。",

        p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理本表格。",

        p_title3: "可獲轉移資料者",
        p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
        p3_b: "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第1段所述的用途；",
        p3_c: "你曾就披露個人資料給予訂明同意；以及",
        p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

        p_title4: "查閱個人資料",
        p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：",
        p4_1: "一級會計主任(公積金)1</br>教育局公積金組</br>香港灣仔皇后大道東213號胡忠大廈15樓1517室",
    },

    errorMsg: {
        E001: "改編後薪金不能高於頂薪點",
        hkidEmpty: "括號內的值不能為空",
        schoolName1: "請輸入一個有效的學校名稱", //學校名稱
        schoolCode1: "請輸入一個有效的學校代碼", //學校代碼
        nameInEnglish: "請輸入一個有效的英文名", //英文名
        nameInChinese: "請輸入一個有效的中文名", //中文名
        englishName: "請輸入一個有效的職員英文姓名",
        chineseName: "請輸入一個有效的職員中文姓名",
        numberOnly: "請輸入一個有效的8位數字",
        monthlySalary: "請輸入一個有效的薪金(總薪級表薪點)",
        refNum: "請輸入一個有效檔號",
        Note001:
            "注 1.所有晉升職員或代理任命的必要程式都應在生效日期之前完成，包括獲得校董會/校董會的批准。 一般情況下，晉升日期和代理任命日期不具有追溯效力。",
        telMax: "電話號碼必須為最多8位數",
        srnMin: "員工檔號必須為8位數",
        schoolCodeMin: "學校代碼必須為4位數",
        min: "請輸入一個有效的價格",
        max: "價格最大值為10",
        maxDecimal: "價格必須為小數後2位",
        amountMin: "此項最小值為0",
        validAmount: "請輸入一個有效金額",
    },
};
export default Form093TC;
